import API from 'api';

const insertContact = (body) => API.post('/contact/send', body);

export default {
  insertContact,
};